import React, { useState } from 'react';
import AnalysisView from '../../component/AnalysisView';
import { PromptListType } from '@op/components/GPT/types';
import { Segment, Row, Col, Justify } from 'tea-component';
import AnalysisCharts from '../../component/AnalysisCharts';
import LeftMetricsCard from '../../component/LeftMetricsCard';
import MentionsBrandHealthChart from '../../component/MentionsBrandHealthChart';
import AnalysisTable from '../../component/AnalysisTable';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { AnalysisSummaryTypeTab } from '../../types';
import TopicKeyword from '../../component/TopicKeyword';
import SingleCheckbox from '@op/components/FilterBoxCommon/filters/single-checkbox';
import { analysisSummaryTab } from '../../constants';
import GPTSummaryContent from './GPTSummaryContent';
import LoadingCard, { TChildrenPropsType } from './LoadingCard';
import useLanguage from '@op/hooks/useLanguage';
import TopicSelectBox from '../../component/TopicSelectBox';
import TopicChartInfo from './TopicChartInfo';

export default function KeywordCard({
  filterValue,
  oriFilterValue,
  isPreviews,
  setApiLoading,
  translateTopic,
  ...props
}: {
  oriFilterValue: any;
  filterValue: any;
  saveTipsElement: any;
  isPreviews: boolean;
  promptList: PromptListType;
  setApiLoading?: (flag: string) => void;
  promptInfo: any;
  setPromptInfo: (value: any, params?: any) => void;
  translateTopic: any;
}) {
  const { formatMessage } = useLanguage();
  const [showKeywordTopic, setShowKeywordTopic] = useState(false);

  return (
    <LoadingCard filterValue={filterValue}>
      {({
        summaryId,
        keywordGptError,
        keywordGptLoading,
        filter,
        value,
        setValue,
        tabFilter,
        chartConfig,
        isTopicAnalysis,
        topicSelect,
        setTopicSelect,
        wholeGameInfo,
        gameInfo,
        topicSelectFilter,
        updateGptParams,
      }: TChildrenPropsType) => (
        <AnalysisView
          filter={filter}
          wholeGameInfo={wholeGameInfo}
          tab="keyword"
          gameInfo={gameInfo}
          isPreviews={isPreviews}
          isTopicAnalysis={isTopicAnalysis}
        >
          <Justify
            left={
              <div
                className="dbo-analysis-summary-tab"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Segment
                  className="segment-light segment-font12 "
                  value={value}
                  onChange={(value: AnalysisSummaryTypeTab) => {
                    buriedBtnPoint('TypeTAB', value);
                    setValue(value);
                  }}
                  options={analysisSummaryTab(formatMessage, tabFilter, value)}
                />
                {isTopicAnalysis && (
                  <TopicSelectBox
                    defaultValue={topicSelect}
                    onChange={setTopicSelect}
                    topicFilter={topicSelectFilter}
                  ></TopicSelectBox>
                )}
              </div>
            }
            right={
              <SingleCheckbox
                onChange={() => setShowKeywordTopic(!showKeywordTopic)}
                key={'singleCheckbox'}
                defaultValue={showKeywordTopic}
                defaultParams={{ text: 'Show Keyword & Topic' }}
              ></SingleCheckbox>
            }
          />

          <Row className="dbo-analysis-card-container">
            <Col span={6}>
              <LeftMetricsCard
                value={value}
                gameInfo={gameInfo}
                filter={filter}
                wholeGameInfo={wholeGameInfo}
              ></LeftMetricsCard>
            </Col>
            <Col span={18}>
              <MentionsBrandHealthChart
                tab={value}
                filter={filter}
                gameInfo={gameInfo}
              ></MentionsBrandHealthChart>
            </Col>
          </Row>
          {/* when it is topic analysis show this.*/}
          {isTopicAnalysis && (
            <Row className="dbo-analysis-card-container">
              <Col span={24}>
                <TopicChartInfo
                  filter={filter}
                  gameInfo={gameInfo}
                />
              </Col>
            </Row>
          )}
          <Row className="dbo-analysis-card-container">
            {chartConfig.map((item: any) => (
              <Col key={item.title} span={12}>
                <AnalysisCharts
                  filter={filter}
                  tab={value}
                  gameInfo={gameInfo}
                  {...item}
                ></AnalysisCharts>
              </Col>
            ))}
          </Row>

          {showKeywordTopic && (
            <Row className="dbo-analysis-card-container">
              <Col span={24}>
                <TopicKeyword
                  filter={filter}
                  translateTopic={translateTopic}
                ></TopicKeyword>
              </Col>
            </Row>
          )}

          <GPTSummaryContent
            isPreviews={isPreviews}
            filter={filter}
            value={value}
            setApiLoading={setApiLoading}
            keywordGptError={keywordGptError}
            keywordGptLoading={keywordGptLoading}
            taskId={summaryId!}
            {...props}
            updateGptParams={updateGptParams}
            stopUpdateGpt={topicSelect.length > 0}
          ></GPTSummaryContent>
          <Row className="dbo-aigc-card-wrapper dbo-analysis-card-container">
            <Col span={24}>
              <AnalysisTable
                tab={value}
                filter={filter}
                oriFilterValue={oriFilterValue}
                gameInfo={gameInfo}
                wholeGameInfo={wholeGameInfo}
                setApiLoading={setApiLoading}
              />
            </Col>
          </Row>
        </AnalysisView>
      )}
    </LoadingCard>
  );
}
